"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDeviceAlarmMessage = exports.buildDeviceAlarmEntry = exports.DEVICE_ALARM_EVENT_TYPE = exports.buildTenantSvixChannels = void 0;
const effect_1 = require("effect");
/**
 * Builds the `key:value` channel list a device message must be scoped to.
 *
 * Svix treats a message with no channels as unscoped, and an unscoped message reaches only the
 * endpoints that declare no channel filter of their own -- every tenant-scoped endpoint silently
 * misses it. Both services that emit device events derive the list here so the scoping rule cannot
 * drift between them.
 *
 * Empty strings are dropped alongside null and undefined: a `tenant:` channel matches no endpoint
 * and reads as scoped, which is worse than being absent.
 */
const buildTenantSvixChannels = (tenant, businessUnit, country) => (0, effect_1.pipe)({ tenant, businessUnit, country }, effect_1.Record.filter(effect_1.Predicate.isTruthy), effect_1.Record.collect((key, value) => `${key}:${value}`));
exports.buildTenantSvixChannels = buildTenantSvixChannels;
exports.DEVICE_ALARM_EVENT_TYPE = 'device.alarm';
/**
 * Builds one `device.alarm` entry.
 *
 * This field set is a contract with external integrators, and it is emitted by two services for
 * the same event type. Built here so a rename or a dropped field cannot land in one service and
 * not the other -- the same reason `buildTenantSvixChannels` lives here rather than in either.
 *
 * `params` is omitted when the alarm declares none, which is wire-identical to the key being
 * present with `undefined`: JSON.stringify drops both.
 */
const buildDeviceAlarmEntry = (device, alarm, resolution) => ({
    // Key order is deliberate and not alphabetical: it reproduces the order integrators have been
    // receiving, and a backend-functions test asserts the serialised body byte for byte. Reordering
    // is harmless to any conformant parser but is still an observable change to a live payload.
    alarmCode: alarm.code,
    autoResolved: resolution.autoResolved,
    countryCode: device.installationAddress?.countryCode ?? null,
    buCode: device.businessUnit?._tag ?? null,
    tenantId: device.tenantId ?? null,
    createdDate: alarm.createdAt,
    resolvedAt: resolution.resolvedAt,
    deviceSerialNumber: alarm.deviceSerialNumber,
    alarmId: alarm.id,
    manufacturingSerialNumber: device.manufacturingSerialNumber,
    ...(alarm.params === undefined ? {} : { params: alarm.params }),
    resolved: resolution.resolved,
    resolvedBy: resolution.resolvedBy,
    source: alarm.source,
    severity: alarm.severity,
});
exports.buildDeviceAlarmEntry = buildDeviceAlarmEntry;
/**
 * Wraps alarm entries in the broadcast envelope.
 *
 * An empty channel list becomes null because that is what Svix reads as unscoped; callers decide
 * whether reaching that state is worth logging, since the two paths differ on how it could arise.
 */
const buildDeviceAlarmMessage = (channels, alarms) => ({
    // Wire order, as above.
    eventType: exports.DEVICE_ALARM_EVENT_TYPE,
    channels: channels.length > 0 ? channels : null,
    data: { alarms },
});
exports.buildDeviceAlarmMessage = buildDeviceAlarmMessage;
//# sourceMappingURL=svix.js.map